module.exports = __webpack_public_path__ + "img/phone_en.a6914018.png";